<template>
  <div>
    <b-modal id="timeOptionModal" size="xl" centered v-model="timeOptionModal" title="لیست نوبت های پزشک" :cancel-title="'بستن'" :ok-title="' انتقال نوبت' "  @cancel="timeOptionModal = false" @ok="moveTurnItem">
      <div class="modal-header-time">
        <div class="g-box" v-if="doctorInfo.planUserId">
          <span>پزشک</span>
          <p>{{ drNew }}</p>
        </div>
        <div class="g-box" v-if="unitTitle">
          <span>واحد</span>
          <p>{{ unitTitle }}</p>
        </div>
        <div class="g-box" v-if="dayNamed && toDate">
          <span>تاریخ</span>
          <p>{{dayNamed}} {{ toDate }} </p>
        </div>
      </div>
      <b-form-group label="نوبت مقصد را انتخاب کنید">
        <b-form-radio-group
          id="radio-group-1"
          class="radio-flex"
          v-model="timeSelected"
          :options="timeOption"
          :aria-describedby="ariaDescribedby"
          name="radio-options"
        ></b-form-radio-group>
      </b-form-group>
    </b-modal>
    <div class="plan-modal plan"  @click.self="closeModal">
      <div class="container">
        <div class="plan-content">
          <div class="plan-wrapper" >
            <!-- <div class="plan-title active">رزرو نوبت</div> -->
            <!-- reserve date  -->
            <b-col style="height: 50px;">
              <b-row class="plan-modal-row">
                <div class="d-flex w-100 justify-content-end p-1">
                  <feather-icon
                    class="cursor-pointer mr-1"
                    icon="XIcon"
                    size="25"
                    @click="closeModal"
                  />
                </div>
              </b-row>
            </b-col>        
            <b-col class="plan-tab-content" :class="{paddingTop :turnUserId && tab === 1 }">
              <b-card v-if="!turnUserId">
                <b-tabs card class="tab-controls" v-model="tab">
                  <b-tab title="جستجوی بیمار" active>
                    <b-card-text>
                      <b-row>
                        <b-col>
                          <b-row class="plan-modal-row">
                            <b-col sm="2" class="mb-md-0">
                              <b-form-group :label="$t('general.date')" label-for="date">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="date"
                                  :value="reserveDate"
                                  aria-describedby="user-day"
                                  disabled
                                />
                                <b-form-text id="user-day"
                                          >{{ dayIndex[keyDay].name }} - {{ dayIndex[keyDay].enName }}
                                </b-form-text>
                              </b-form-group>
                            </b-col>

                            <b-col sm="2" class="mb-md-0">
                              <b-form-group
                                :label="$t('general.startTime')"
                                label-for="start-time"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  id="start-time"
                                  :value="reserveFromTime"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>

                            <b-col sm="2" class="mb-md-0">
                              <b-form-group
                                :label="$t('general.endTime')"
                                label-for="end-time"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  id="end-time"
                                  :value="reserveEndTime"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                            <b-form class="search-input-group" @submit="findUser">
                              <b-input-group class="search-input-group">
                                <b-form-input
                                  placeholder="کد ملی بیمار"
                                  v-model="searchTerm"
                                  type="text"
                                  dir="ltr"
                                  :minLength="10"
                                  :maxLength="10"
                                ></b-form-input>
                                <b-input-group-append>
                                  <b-button
                                    text="Button"
                                    variant="success"
                                    @click.submit="findUser"
                                    >جستجو</b-button
                                  >
                                </b-input-group-append>
                              </b-input-group>
                            </b-form>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-tab>
                  <b-tab title="جستجوی بیمار غیر ایرانی">
                    <b-card-text>
                      <b-row>
                        <b-col>
                          <b-row class="plan-modal-row">
                            <b-col sm="2" class="mb-md-0">
                              <b-form-group :label="$t('general.date')" label-for="date">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="date"
                                  :value="reserveDate"
                                  aria-describedby="user-day"
                                  disabled
                                />
                                <b-form-text id="user-day"
                                          >{{ dayIndex[keyDay].name }} - {{ dayIndex[keyDay].enName }}
                                </b-form-text>
                              </b-form-group>
                            </b-col>

                            <b-col sm="2" class="mb-md-0">
                              <b-form-group
                                :label="$t('general.startTime')"
                                label-for="start-time"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  id="start-time"
                                  :value="reserveFromTime"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>

                            <b-col sm="2" class="mb-md-0">
                              <b-form-group
                                :label="$t('general.endTime')"
                                label-for="end-time"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  id="end-time"
                                  :value="reserveEndTime"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="3" md="4" sm="6" xl="2">
                          <b-form-group
                            :label="$t('user.nationality')"
                            label-for="user-nationality"
                          >
                            <my-v-select
                              v-if="countries && countries.length > 0"
                              :key="country"
                              id="user-nationality"
                              v-model="country"
                              :multiple="false"
                              :options="
                                countries.length
                                  ? countries.filter(
                                      (c) => c.nativeName !== 'Irān'
                                    )
                                  : []
                              "
                              :translate="false"
                              :concat-label="['title.fa']"
                              :reduce-field="['_id']"
                              :searchable="true"
                              :filterable="true"
                              @input="countrySelected"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col lg="3" md="4" sm="6" xl="2">
                          <b-form-group
                            :label="$t('user.fullName')"
                            label-for="user-fullName"
                          >
                            <b-form-input
                              id="user-fullName"
                              v-model="fullNameSearch"
                              autocomplete="off"
                              @keypress.enter="findUser"
                              @keypress="validateInput"
                            />
                          </b-form-group>
                        </b-col>
                        <!-- <b-col lg="3" md="4" sm="6" xl="2">
                          <b-form-group
                            :label="$t('user.lastName')"
                            label-for="user-lastname"
                          >
                            <b-form-input
                              id="user-lastname"
                              v-model="lastNameSearch"
                              autocomplete="off"
                            />
                          </b-form-group>
                        </b-col> -->
                        <b-col lg="3" md="3" sm="3" xl="2">
                          <b-form-group
                            :label="$t('user.fathersName')"
                            label-for="user-fatherName"
                          >
                            <div class="form-label-group">
                              <b-form-input
                                id="user-fatherName"
                                v-model="fatherNameSearch"
                                @keypress.enter="findUser"
                                @keypress="validateInput"
                              />
                            </div>
                          </b-form-group>
                        </b-col>
                        <b-col
                          class="d-flex align-items-center"
                          style="margin-top: 20px"
                        >
                          <b-button
                            style="height: 38px"
                            @click.submit="findUser"
                            variant="success"
                            >جستجو</b-button
                          >
                          <b-button
                            variant="warning"
                            size="md"
                            class="d-flex ml-1 justify-content-center"
                            @click="NewPatientR"
                            style="width: 200px"
                            v-if="newPatientNonIr"
                       >
                            ثبت بیمار جدید
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-tab>
                  <!-- -->
                  <BCardText
                    v-if="showForm || turnUserId"
                    class="mt-1 has-double-border"
                  >
                    <div v-if="tab === 1 && showFormP" class="table-wrapper">
                      <table class="table table-bordered mb-4 text-center">
                        <tr>
                          <td>نام</td>
                          <td>نام خانوادگی</td>
                          <td>نام پدر</td>
                          <td>شماره موبایل</td>
                          <td>عملیات</td>
                        </tr>
                        <template v-if="foreignerList.length > 0">
                          <tr
                            v-for="(item, index) in foreignerList"
                            :key="index"
                          >
                            <td>{{ item.firstName }}</td>
                            <td>{{ item.lastName }}</td>
                            <td>{{ item.fatherName }}</td>
                            <td>{{ item.mobile }}</td>
                            <td>
                              <b-button
                                variant="primary"
                                size="sm"
                                class="d-flex mx-auto"
                                @click="reserve(item)"
                              >
                                ثبت بیمار
                              </b-button>
                            </td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="12">
                            <div class="py-1">
                              بیمار یافت نشد. برای افزودن بیمار جدید, ثبت بیمار جدید را انتخاب کنید.
                               .
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <BForm @submit.prevent autocomplete="off">
                      <b-row v-if="newPatient && tab === 1 || tab === 0">
                        <b-col lg="3" md="4" sm="6" xl="2" v-if="tab === 1">
                          <b-form-group
                            :label="$t('user.nationality')"
                            label-for="user-nationality"
                          >
                            <my-v-select
                              v-if="countries && countries.length > 0"
                              :key="country"
                              id="user-nationality"
                              v-model="country"
                              :multiple="false"
                              :options="
                                countries.length
                                  ? countries.filter(
                                      (c) => c.nativeName !== 'Irān'
                                    )
                                  : []
                              "
                              :translate="false"
                              :concat-label="['title.fa']"
                              :reduce-field="['_id']"
                              :searchable="true"
                              :filterable="true"
                              @input="countrySelected"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col lg="2" md="4" sm="6">
                          <b-form-group
                            :label="$t('user.gender')"
                            label-for="user-gender"
                            :invalid-feedback="
                              invalidFeedbackGender
                                ? $t(`validation.${invalidFeedbackGender}`, {
                                    field: $t('user.gender'),
                                  })
                                : ''
                            "
                            :class="{
                              'required-group': !$v.gender.required,
                            }"
                            :state="
                              $v.gender.$dirty
                                ? !$v.gender.$invalid === false
                                  ? false
                                  : null
                                : null
                            "
                          >
                            <b-form-radio-group
                              id="user-gender"
                              ref="gender"
                              v-model="gender"
                              :disabled="!newPatient"
                              :options="genders"
                              :state="
                                $v.gender.$dirty
                                  ? !$v.gender.$invalid === false
                                    ? false
                                    : null
                                  : null
                              "
                            ></b-form-radio-group>
                          </b-form-group>
                        </b-col>
                        <b-col lg="3" md="4" sm="6" xl="2" style="margin-left:60px">
                          <b-form-group
                            :invalid-feedback="
                              invalidFeedbackFirstName
                                ? $t(`validation.${invalidFeedbackFirstName}`, {
                                    field: $t('user.firstName'),
                                  })
                                : ''
                            "
                            :label="$t('user.firstName')"
                            :state="
                              $v.firstName.$dirty
                                ? !$v.firstName.$invalid === false
                                  ? false
                                  : null
                                : null
                            "
                            :class="{
                              'required-group': !$v.firstName.required,
                            }"
                            label-for="user-first-name"
                          >
                            <b-form-input
                              id="user-first-name"
                              v-model="firstName"
                             :disabled="!newPatient"
                             style="width:230px"
                              :state="
                                $v.firstName.$dirty
                                  ? !$v.firstName.$invalid === false
                                    ? false
                                    : null
                                  : null
                              "
                              @keydown="preventNumbers($event)"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col lg="3" md="4" sm="6" xl="2" style="margin-left:60px">
                          <b-form-group
                            :invalid-feedback="
                              invalidFeedbackLastname
                                ? $t(`validation.${invalidFeedbackLastname}`, {
                                    field: $t('user.lastName'),
                                  })
                                : ''
                            "
                            :label="$t('user.lastName')"
                            :state="
                              $v.lastName.$dirty
                                ? !$v.lastName.$invalid === false
                                  ? false
                                  : null
                                : null
                            "
                            :class="{
                              'required-group': !$v.lastName.required,
                            }"
                            label-for="user-lastname"
                          >
                            <b-form-input
                              id="user-lastname"
                              v-model="lastName"
                             :disabled="!newPatient"
                             style="width:230px"
                              :state="
                                $v.lastName.$dirty
                                  ? !$v.lastName.$invalid === false
                                    ? false
                                    : null
                                  : null
                              "
                              @input="$v.lastName.$touch()"
                              @keydown="preventNumbers($event)"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col lg="3" md="3" sm="3" xl="2" v-if="tab === 1" style="margin-left:60px">
                          <b-form-group
                            :invalid-feedback="
                              invalidFeedbackFatherName
                                ? $t(
                                    `validation.${invalidFeedbackFatherName}`,
                                    {
                                      field: $t('user.fathersName'),
                                    }
                                  )
                                : ''
                            "
                            :label="$t('user.fathersName')"
                            label-for="user-fatherName"
                            :state="
                              $v.fatherName.$dirty
                                ? !$v.fatherName.$invalid === false
                                  ? false
                                  : null
                                : null
                            "
                            :class="{
                              'required-group': !$v.fatherName.required,
                            }"
                          >
                            <div class="form-label-group">
                              <b-form-input
                                id="user-fatherName"
                                v-model="fatherName"
                                style="width:230px"
                                @keydown="preventNumbers($event)"
                                :state="
                                  $v.fatherName.$dirty
                                    ? !$v.fatherName.$invalid === false
                                      ? false
                                      : null
                                    : null
                                "
                              />
                            </div>
                          </b-form-group>
                        </b-col>
                        
                        <!-- Item Mobile -->
                        <b-col lg="3" md="4" sm="6" xl="2">
                          <b-form-group
                            :invalid-feedback="
                              invalidFeedbackMobile
                                ? $t(`validation.${invalidFeedbackMobile}`, {
                                    field: $t('user.mobile'),
                                    current: $t('user.anotherMobile'),
                                  })
                                : ''
                            "
                            :label="$t('user.mobile')"
                            :state="
                              $v.mobile.$dirty
                                ? !$v.mobile.$invalid === false
                                  ? false
                                  : null
                                : null
                            "
                            :class="{
                              'required-group': !$v.mobile.required,
                            }"
                            label-for="user-mobile"
                          >
                            <!-- :state="$v.mobiles.$dirty ? !$v.mobile.$invalid : null" -->
                            <!-- :state="$v.mobile.$dirty ? !$v.mobile.$invalid : null" -->
                            <b-form-input
                              id="user-mobile"
                              v-model="mobile"
                              :disabled="!newPatient"
                              :state="
                                $v.mobile.$dirty
                                  ? !$v.mobile.$invalid === false
                                    ? false
                                    : null
                                  : null
                              "
                              aria-describedby="user-mobile-help"
                              type="number"
                              @keypress="preventMobileType($event)"
                              dir="ltr"
                            />
                            <b-form-text  v-if="tab === 0" id="user-mobile-help"
                              >{{ $t("hint.mobile") }}
                            </b-form-text>
                            <b-form-text  v-else id="user-mobile-help"
                              >
                            </b-form-text>
                          </b-form-group>
                        </b-col>
                        <b-col lg="3" md="4" sm="6" xl="2" v-if="tab === 1">
                          <b-form-group
                            :label="$t('user.dialCode')"
                            label-for="user-mobile-dialcode"
                          >
                            <!-- <my-v-select
                              :key="mobileCountryId"
                              id="user-mobile-dialcode"
                              v-model="mobileCountryId"
                              :multiple="false"
                              :options="
                                countries.length
                                  ? countries.filter(
                                      (c) => c.nativeName !== 'Irān'
                                    )
                                  : []
                              "
                              :translate="false"
                              :concat-label="['title.fa', 'phoneCode']"
                              :refuce-field="['_id']"
                              :searchable="true"
                              :filterable="true"
                              @input="countrySelected"
                            /> -->
                            <v-select
                            :items="countriesWithCode.length ? countriesWithCode.filter((c) => c.nativeName !== 'Irān') : []"
                            v-model="mobileCountryId"
                            item-text="titleAndCode"
                            item-value="_id"
                            @input="countrySelected"
                            attach
                            class="selectCountries"
                          >
                          <template v-slot:selection="{ item }">
                            <img :src="item.wikipedia_image" style="width:20px; height:20px; margin-left:10px">
                            {{ item.phoneCode }}
                         </template>
                            <template v-slot:item="{ item }">
                              <img :src="item.wikipedia_image" style="width:20px; height:20px; margin-left:10px">
                              {{ item.phoneCode }}
                            </template>
                          </v-select>
                          </b-form-group>

                        </b-col>
                        <b-col lg="3" md="4" sm="6" xl="2" v-if="tab === 0">
                          <b-form-group
                            :invalid-feedback="
                              invalidFeedbackNationalCode
                                ? $t(
                                    `validation.${invalidFeedbackNationalCode}`,
                                    {
                                      field: $t('user.nationalCode'),
                                      current: $t('user.spouseNationalCode'),
                                    }
                                  )
                                : ''
                            "
                            :label="$t('user.nationalCode')"
                            :state="
                              $v.nationalCode.$dirty
                                ? !$v.nationalCode.$invalid === false
                                  ? false
                                  : null
                                : null
                            "
                            :class="{
                              'required-group': !$v.nationalCode.required,
                            }"
                            label-for="user-nationalcode"
                          >
                            <b-form-input
                              id="user-nationalcode"
                              v-model="nationalCode"
                              :disabled="!newPatient"
                              :state="
                                $v.nationalCode.$dirty
                                  ? !$v.nationalCode.$invalid === false
                                    ? false
                                    : null
                                  : null
                              "
                              aria-describedby="user-nationalcode-feedback"
                              type="number"
                              @input="$v.nationalCode.$touch()"
                              @keypress="preventNationalType($event)"
                              dir="ltr"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col sm="12" class="pt-2" v-if="turnUserId">
                          <b-form-checkbox
                            id="come"
                            name="come"
                            v-model="isCome"
                            @change="changeIsCome"
                            :disabled="!showCome"
                          >
                            مراجعه شده
                          </b-form-checkbox>
                        </b-col>
                        <b-col sm="12" class="pt-2 d-flex justify-content-end">
                          <!-- <b-button
                            variant="warning"
                            size="md"
                            class="d-flex mr-1 justify-content-center"
                            @click="NewPatientR"
                            style="width: 200px"
                            v-if="tab === 1 && foreignerList.length > 0"
                       >
                            ثبت بیمار جدید
                          </b-button> -->
                          <b-button
                            variant="success"
                            size="md"
                            class="d-flex  justify-content-center"
                            @click="FinalRegistration"
                            style="width: 200px"
                          >
                            ثبت
                          </b-button>
                        </b-col>
                      </b-row>
                    </BForm>
                  </BCardText>
                  <div class="reserve-modal plan-modal-footer pb-3">
                    <!-- <b-button
                    variant="success"
                    size="sm"
                    class="p-0"
                    @click="reserve"
                    v-if="!turnUserId"
                  >
                    ثبت
                  </b-button> -->
                    <b-button
                      variant="warning"
                      size="sm"
                      class="mx-1 p-0"
                      v-if="turnUserId"
                      @click="deleteReserve"
                    >
                      حذف
                    </b-button>
                    <b-button
                      variant="info"
                      v-if="turnUserId"
                      size="sm"
                      class="mr-1 p-0"
                      @click="getTurnInfo"
                    >
                      چاپ
                    </b-button>
                    <!-- <b-button variant="danger" size="sm" class="p-0" @click="closeModal">
                      بستن
                    </b-button> -->
                  </div>
                </b-tabs>
              </b-card>
              <!-- reserved data  -->
              <b-card v-if="turnUserId">
                <b-tabs card class="tab-controls" v-model="tab">
                  <b-tab title="اطلاعات تکمیلی نوبت" active>
                    <b-row>
                        <b-col>
                          <b-row class="plan-modal-row">
                            <b-col sm="2" class="mb-md-0">
                              <b-form-group :label="$t('general.date')" label-for="date">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="date"
                                  :value="reserveDate"
                                  aria-describedby="user-day"
                                  disabled
                                />
                                <b-form-text id="user-day"
                                          >{{ dayIndex[keyDay].name }} - {{ dayIndex[keyDay].enName }}
                                </b-form-text>
                              </b-form-group>
                            </b-col>

                            <b-col sm="2" class="mb-md-0">
                              <b-form-group
                                :label="$t('general.startTime')"
                                label-for="start-time"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  id="start-time"
                                  :value="reserveFromTime"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>

                            <b-col sm="2" class="mb-md-0">
                              <b-form-group
                                :label="$t('general.endTime')"
                                label-for="end-time"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  id="end-time"
                                  :value="reserveEndTime"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    <BCardText
                      v-if="showForm || turnUserId"
                      class="mt-1 has-double-border"
                      >
                      <div v-if="tab === 1" class="table-wrapper">
                        <table class="table table-bordered mb-4 text-center">
                          <tr>
                            <td>نام</td>
                            <td>نام خانوادگی</td>
                            <td>نام پدر</td>
                            <td>شماره موبایل</td>
                            <td>عملیات</td>
                          </tr>
                          <template v-if="foreignerList.length > 0">
                            <tr
                              v-for="(item, index) in foreignerList"
                              :key="index"
                            >
                              <td>{{ item.firstName }}</td>
                              <td>{{ item.lastName }}</td>
                              <td>{{ item.fatherName }}</td>
                              <td>{{ item.mobile }}</td>
                              <td>
                                <b-button
                                  variant="primary"
                                  size="sm"
                                  class="d-flex mx-auto"
                                  @click="selectForeignUser(item)"
                                >
                                  انتخاب بیمار
                                </b-button>
                              </td>
                            </tr>
                          </template>
                          <tr v-else>
                            <td colspan="12">
                              <div class="py-1">
                                بیمار یافت نشد. برای افزودن بیمار جدید, ثبت بیمار جدید را انتخاب کنید.

                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <BForm @submit.prevent autocomplete="off">
                        <b-row v-if="newPatient && tab===1 || tab===0">
                          <b-col lg="3" md="4" sm="6" xl="2" v-if="tab === 1">
                            <b-form-group
                              :label="$t('user.nationality')"
                              label-for="user-nationality"
                            >
                              <my-v-select
                                v-if="countries && countries.length > 0"
                                :key="country"
                                id="user-nationality"
                                v-model="country"
                                :multiple="false"
                                :options="
                                  countries.length
                                    ? countries.filter(
                                        (c) => c.nativeName !== 'Irān'
                                      )
                                    : []
                                "
                                :translate="false"
                                :concat-label="['title.fa']"
                                :reduce-field="['_id']"
                                :searchable="true"
                                :filterable="true"
                                @input="countrySelected"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col lg="2" md="4" sm="6">
                            <b-form-group
                              :label="$t('user.gender')"
                              label-for="user-gender"
                              :invalid-feedback="
                                invalidFeedbackGender
                                  ? $t(`validation.${invalidFeedbackGender}`, {
                                      field: $t('user.gender'),
                                    })
                                  : ''
                              "
                              :class="{
                                'required-group': !$v.gender.required,
                              }"
                              :state="
                                $v.gender.$dirty
                                  ? !$v.gender.$invalid === false
                                    ? false
                                    : null
                                  : null
                              "
                            >
                              <b-form-radio-group
                                id="user-gender"
                                ref="gender"
                                v-model="gender"
                                :disabled="turnUserId && turnUserId.length > 0"
                                :options="genders"
                                :state="
                                  $v.gender.$dirty
                                    ? !$v.gender.$invalid === false
                                      ? false
                                      : null
                                    : null
                                "
                              ></b-form-radio-group>
                            </b-form-group>
                          </b-col>
                          <b-col lg="3" md="4" sm="6" xl="2">
                            <b-form-group
                              :invalid-feedback="
                                invalidFeedbackFirstName
                                  ? $t(`validation.${invalidFeedbackFirstName}`, {
                                      field: $t('user.firstName'),
                                    })
                                  : ''
                              "
                              :label="$t('user.firstName')"
                              :state="
                                $v.firstName.$dirty
                                  ? !$v.firstName.$invalid === false
                                    ? false
                                    : null
                                  : null
                              "
                              :class="{
                                'required-group': !$v.firstName.required,
                              }"
                              label-for="user-first-name"
                            >
                              <b-form-input
                                id="user-first-name"
                                v-model="firstName"
                                :disabled="turnUserId && turnUserId.length > 0"
                                :state="
                                  $v.firstName.$dirty
                                    ? !$v.firstName.$invalid === false
                                      ? false
                                      : null
                                    : null
                                "
                                @keydown="preventNumbers($event)"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col lg="3" md="4" sm="6" xl="2">
                            <b-form-group
                              :invalid-feedback="
                                invalidFeedbackLastname
                                  ? $t(`validation.${invalidFeedbackLastname}`, {
                                      field: $t('user.lastName'),
                                    })
                                  : ''
                              "
                              :label="$t('user.lastName')"
                              :state="
                                $v.lastName.$dirty
                                  ? !$v.lastName.$invalid === false
                                    ? false
                                    : null
                                  : null
                              "
                              :class="{
                                'required-group': !$v.lastName.required,
                              }"
                              label-for="user-lastname"
                            >
                              <b-form-input
                                id="user-lastname"
                                v-model="lastName"
                                :disabled="turnUserId && turnUserId.length > 0"
                                :state="
                                  $v.lastName.$dirty
                                    ? !$v.lastName.$invalid === false
                                      ? false
                                      : null
                                    : null
                                "
                                @input="$v.lastName.$touch()"
                                @keydown="preventNumbers($event)"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col lg="3" md="3" sm="3" xl="2" v-if="tab === 1">
                            <b-form-group
                              :invalid-feedback="
                                invalidFeedbackFatherName
                                  ? $t(
                                      `validation.${invalidFeedbackFatherName}`,
                                      {
                                        field: $t('user.fathersName'),
                                      }
                                    )
                                  : ''
                              "
                              :label="$t('user.fathersName')"
                              label-for="user-fatherName"
                              :state="
                                $v.fatherName.$dirty
                                  ? !$v.fatherName.$invalid === false
                                    ? false
                                    : null
                                  : null
                              "
                              :class="{
                                'required-group': !$v.fatherName.required,
                              }"
                            >
                              <div class="form-label-group">
                                <b-form-input
                                  id="user-fatherName"
                                  v-model="fatherName"
                                  :state="
                                    $v.fatherName.$dirty
                                      ? !$v.fatherName.$invalid === false
                                        ? false
                                        : null
                                      : null
                                  "
                                />
                              </div>
                            </b-form-group>
                          </b-col>
                          <b-col lg="3" md="4" sm="6" xl="2" v-if="tab === 1">
                            <b-form-group
                              :label="$t('user.dialCode')"
                              label-for="user-mobile-dialcode"
                            >
                              <my-v-select
                                :key="mobileCountryId"
                                id="user-mobile-dialcode"
                                v-model="mobileCountryId"
                                :multiple="false"
                                :options="
                                  countries.length
                                    ? countries.filter(
                                        (c) => c.nativeName !== 'Irān'
                                      )
                                    : []
                                "
                                :translate="false"
                                :concat-label="['title.fa', 'phoneCode']"
                                :refuce-field="['_id']"
                                :searchable="true"
                                :filterable="true"
                                @input="countrySelected"
                              />
                            </b-form-group>
                          </b-col>
                          <!-- Item Mobile -->
                          <b-col lg="3" md="4" sm="6" xl="2">
                            <b-form-group
                              :invalid-feedback="
                                invalidFeedbackMobile
                                  ? $t(`validation.${invalidFeedbackMobile}`, {
                                      field: $t('user.mobile'),
                                      current: $t('user.anotherMobile'),
                                    })
                                  : ''
                              "
                              :label="$t('user.mobile')"
                              :state="
                                $v.mobile.$dirty
                                  ? !$v.mobile.$invalid === false
                                    ? false
                                    : null
                                  : null
                              "
                              :class="{
                                'required-group': !$v.mobile.required,
                              }"
                              label-for="user-mobile"
                            >
                              <!-- :state="$v.mobiles.$dirty ? !$v.mobile.$invalid : null" -->
                              <!-- :state="$v.mobile.$dirty ? !$v.mobile.$invalid : null" -->
                              <b-form-input
                                id="user-mobile"
                                v-model="mobile"
                                :disabled="turnUserId && turnUserId.length > 0"
                                :state="
                                  $v.mobile.$dirty
                                    ? !$v.mobile.$invalid === false
                                      ? false
                                      : null
                                    : null
                                "
                                aria-describedby="user-mobile-help"
                                type="number"
                                @keypress="preventMobileType($event)"
                                dir="ltr"
                              />
                              <b-form-text id="user-mobile-help"
                                >{{ $t("hint.mobile") }}
                              </b-form-text>
                            </b-form-group>
                          </b-col>

                          <b-col lg="3" md="4" sm="6" xl="2" v-if="tab === 0 && nationalCode && nationalCode.length > 0 && irani">
                            <b-form-group
                              :invalid-feedback="
                                invalidFeedbackNationalCode
                                  ? $t(
                                      `validation.${invalidFeedbackNationalCode}`,
                                      {
                                        field: $t('user.nationalCode'),
                                        current: $t('user.spouseNationalCode'),
                                      }
                                    )
                                  : ''
                              "
                              :label="$t('user.nationalCode')"
                              :state="
                                $v.nationalCode.$dirty
                                  ? !$v.nationalCode.$invalid === false
                                    ? false
                                    : null
                                  : null
                              "
                              :class="{
                                'required-group': !$v.nationalCode.required,
                              }"
                              label-for="user-nationalcode"
                            >
                              <b-form-input
                                id="user-nationalcode"
                                v-model="nationalCode"
                                :disabled="turnUserId && turnUserId.length > 0"
                                :state="
                                  $v.nationalCode.$dirty
                                    ? !$v.nationalCode.$invalid === false
                                      ? false
                                      : null
                                    : null
                                "
                                aria-describedby="user-nationalcode-feedback"
                                type="number"
                                @input="$v.nationalCode.$touch()"
                                @keypress="preventNationalType($event)"
                                dir="ltr"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col lg="3" md="4" sm="6" xl="2" v-else>
                            <b-form-group
                              :label="$t('user.nationality')"
                              label-for="user-nationality"
                            >
                              <b-form-input
                                id="user-nationality"
                                v-model="nationality"
                                :disabled="turnUserId && turnUserId.length > 0"
                                aria-describedby="user-nationalcode-feedback"
                                type="text"
                              />
                            </b-form-group>
                          </b-col>
                          <b-col sm="12" class="pt-2">
                            <b-form-checkbox
                              id="come"
                              name="come"
                              v-model="isCome"
                              @change="changeIsCome"
                              :disabled="!turnUserId || !showCome"
                              
                            >
                              مراجعه شده
                            </b-form-checkbox>
                          </b-col>
                          <b-col sm="12" class="pt-2">
                            <b-button
                              variant="success"
                              size="md"
                              class="d-flex ml-auto justify-content-center"
                              @click="reserve"
                              v-if="!turnUserId"
                              style="width: 200px"
                            >
                              ثبت
                            </b-button>
                          </b-col>
                        </b-row>
                      </BForm>
                    </BCardText>
                    <b-row v-else class="p-1">
                      <b-col lg="2" md="4" sm="6">
                        <b-form-group
                          :label="$t('user.gender')"
                          label-for="user-gender"
                          :invalid-feedback="
                            invalidFeedbackGender
                              ? $t(`validation.${invalidFeedbackGender}`, {
                                  field: $t('user.gender'),
                                })
                              : ''
                          "
                          :class="{ 'required-group': !$v.gender.required }"
                          :state="
                            $v.gender.$dirty
                              ? !$v.gender.$invalid === false
                                ? false
                                : null
                              : null
                          "
                        >
                          <b-form-radio-group
                            id="user-gender"
                            ref="gender"
                            v-model="gender"
                            :disabled="turnUserId && turnUserId.length > 0"
                            :options="genders"
                            :state="
                              $v.gender.$dirty
                                ? !$v.gender.$invalid === false
                                  ? false
                                  : null
                                : null
                            "
                          ></b-form-radio-group>
                        </b-form-group>
                      </b-col>
                      <b-col lg="3" md="4" sm="6" xl="2">
                        <b-form-group
                          :invalid-feedback="
                            invalidFeedbackFirstName
                              ? $t(`validation.${invalidFeedbackFirstName}`, {
                                  field: $t('user.firstName'),
                                })
                              : ''
                          "
                          :label="$t('user.firstName')"
                          :state="
                            $v.firstName.$dirty
                              ? !$v.firstName.$invalid === false
                                ? false
                                : null
                              : null
                          "
                          :class="{ 'required-group': !$v.firstName.required }"
                          label-for="user-first-name"
                        >
                          <b-form-input
                            id="user-first-name"
                            v-model="firstName"
                            :disabled="turnUserId && turnUserId.length > 0"
                            :state="
                              $v.firstName.$dirty
                                ? !$v.firstName.$invalid === false
                                  ? false
                                  : null
                                : null
                            "
                            @keydown="preventNumbers($event)"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col lg="3" md="4" sm="6" xl="2">
                        <b-form-group
                          :invalid-feedback="
                            invalidFeedbackLastname
                              ? $t(`validation.${invalidFeedbackLastname}`, {
                                  field: $t('user.lastName'),
                                })
                              : ''
                          "
                          :label="$t('user.lastName')"
                          :state="
                            $v.lastName.$dirty
                              ? !$v.lastName.$invalid === false
                                ? false
                                : null
                              : null
                          "
                          :class="{ 'required-group': !$v.lastName.required }"
                          label-for="user-lastname"
                        >
                          <b-form-input
                            id="user-lastname"
                            v-model="lastName"
                            :disabled="turnUserId && turnUserId.length > 0"
                            :state="
                              $v.lastName.$dirty
                                ? !$v.lastName.$invalid === false
                                  ? false
                                  : null
                                : null
                            "
                            @input="$v.lastName.$touch()"
                            @keydown="preventNumbers($event)"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col lg="3" md="4" sm="6" xl="2" class="d-none">
                        <b-form-group
                          :label="$t('user.nationality')"
                          label-for="user-nationality"
                        >
                          <my-v-select
                            v-if="countries && countries.length > 0"
                            :key="country"
                            :disabled="turnUserId && turnUserId.length > 0"
                            id="user-nationality"
                            v-model="country"
                            :multiple="false"
                            :options="countries.length ? countries : []"
                            :translate="false"
                            :concat-label="['title.fa']"
                            :reduce-field="['_id']"
                            :searchable="true"
                            :filterable="true"
                            @input="countrySelected"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col lg="3" md="4" sm="6" xl="2" class="d-none">
                        <b-form-group
                          :label="$t('user.dialCode')"
                          label-for="user-mobile-dialcode"
                        >
                          <my-v-select
                            v-if="countries && countries.length > 0"
                            :key="mobileCountryId"
                            :disabled="turnUserId && turnUserId.length > 0"
                            id="user-mobile-dialcode"
                            v-model="mobileCountryId"
                            :multiple="false"
                            :options="countries.length ? countries : []"
                            :translate="false"
                            :concat-label="['title.fa', 'phoneCode']"
                            :refuce-field="['_id']"
                            :searchable="true"
                            :filterable="true"
                            @input="countrySelected"
                          />
                        </b-form-group>
                      </b-col>
                      <!-- Item Mobile -->
                      <b-col lg="3" md="4" sm="6" xl="2">
                        <b-form-group
                          :invalid-feedback="
                            invalidFeedbackMobile
                              ? $t(`validation.${invalidFeedbackMobile}`, {
                                  field: $t('user.mobile'),
                                  current: $t('user.anotherMobile'),
                                })
                              : ''
                          "
                          :label="$t('user.mobile')"
                          :state="
                            $v.mobile.$dirty
                              ? !$v.mobile.$invalid === false
                                ? false
                                : null
                              : null
                          "
                          :class="{ 'required-group': !$v.mobile.required }"
                          label-for="user-mobile"
                        >
                          <!-- :state="$v.mobiles.$dirty ? !$v.mobile.$invalid : null" -->
                          <!-- :state="$v.mobile.$dirty ? !$v.mobile.$invalid : null" -->
                          <b-form-input
                            id="user-mobile"
                            v-model="mobile"
                            :disabled="turnUserId && turnUserId.length > 0"
                            :state="
                              $v.mobile.$dirty
                                ? !$v.mobile.$invalid === false
                                  ? false
                                  : null
                                : null
                            "
                            aria-describedby="user-mobile-help"
                            type="number"
                            @keypress="preventMobileType($event)"
                            dir="ltr"
                          />
                          <b-form-text id="user-mobile-help"
                            >{{ $t("hint.mobile") }}
                          </b-form-text>
                        </b-form-group>
                      </b-col>

                      <b-col lg="3" md="4" sm="6" xl="2" v-if="nationalCode">
                        <b-form-group
                          :invalid-feedback="
                            invalidFeedbackNationalCode
                              ? $t(`validation.${invalidFeedbackNationalCode}`, {
                                  field: $t('user.nationalCode'),
                                  current: $t('user.spouseNationalCode'),
                                })
                              : ''
                          "
                          :label="$t('user.nationalCode')"
                          :state="
                            $v.nationalCode.$dirty
                              ? !$v.nationalCode.$invalid === false
                                ? false
                                : null
                              : null
                          "
                          :class="{ 'required-group': !$v.nationalCode.required }"
                          label-for="user-nationalcode"
                        >
                          <b-form-input
                            id="user-nationalcode"
                            v-model="nationalCode"
                            :disabled="turnUserId && turnUserId.length > 0"
                            :state="
                              $v.nationalCode.$dirty
                                ? !$v.nationalCode.$invalid === false
                                  ? false
                                  : null
                                : null
                            "
                            aria-describedby="user-nationalcode-feedback"
                            type="number"
                            @input="$v.nationalCode.$touch()"
                            @keypress="preventNationalType($event)"
                            dir="ltr"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <div class="reserve-modal plan-modal-footer pb-3">
                      <!-- <b-button
                      variant="success"
                      size="sm"
                      class="p-0"
                      @click="reserve"
                      v-if="!turnUserId"
                    >
                      ثبت
                    </b-button> -->
                      <b-button
                        variant="warning"
                        size="sm"
                        class="mx-1 p-0"
                        v-if="turnUserId"
                        @click="deleteReserve"
                      >
                        حذف
                      </b-button>
                      <b-button
                        variant="info"
                        v-if="turnUserId"
                        size="sm"
                        class="mr-1 p-0"
                        @click="getTurnInfo"
                      >
                        چاپ
                      </b-button>
                      <!-- <b-button variant="danger" size="sm" class="p-0" @click="closeModal">
                        بستن
                      </b-button> -->
                    </div>
                  </b-tab>
                  <b-tab class="transfer" title="انتقال نوبت" :disabled="past">
                    <b-col v-if="turnUserId">
                      <b-row>
                        <b-col>
                          <b-row class="plan-modal-row">
                            <b-col sm="2" class="mb-md-0">
                              <b-form-group :label="$t('general.date')" label-for="date">
                                <input
                                  type="text"
                                  class="form-control"
                                  id="date"
                                  :value="reserveDate"
                                  aria-describedby="user-day"
                                  disabled
                                />
                                <b-form-text id="user-day"
                                          >{{ dayIndex[keyDay].name }} - {{ dayIndex[keyDay].enName }}
                                </b-form-text>
                              </b-form-group>
                            </b-col>

                            <b-col sm="2" class="mb-md-0">
                              <b-form-group
                                :label="$t('general.startTime')"
                                label-for="start-time"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  id="start-time"
                                  :value="reserveFromTime"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>

                            <b-col sm="3" class="mb-md-0">
                              <b-form-group
                                :label="$t('general.endTime')"
                                label-for="end-time"
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  id="end-time"
                                  :value="reserveEndTime"
                                  disabled
                                />
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      
                      <b-row class="p-1 m-0">
                            <b-col sm="4" class="mb-md-0">
                              <b-form-group
                                label="انتخاب پزشک"
                                label-for="chooseDoctor"
                              >
                                <my-v-select
                                  v-if="doctorOptions" 
                                  id="chooseDoctor"
                                  v-model="doctorSelected"
                                  :multiple="false"
                                  :options="doctorOptions.length ? doctorOptions : []"
                                  :translate="false"
                                  :searchable="true"
                                  :filterable="true"
                                  :clearable="true"
                                  @input="doctorSelectedMove"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col sm="4" class="mb-md-0" v-if="doctorSelected && unitOptions.length != 0">
                              <b-form-group
                                label="انتخاب واحد"
                                label-for="chooseUnit"
                              >
                                <my-v-select
                                  v-if="unitOptions" 
                                  id="chooseUnit"
                                  v-model="unitSelected"
                                  :multiple="false"
                                  :options="unitOptions.length ? unitOptions : []"
                                  :translate="false"
                                  :searchable="true"
                                  :filterable="true"
                                  :clearable="true"
                                  @input="unitSelectedMove"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col sm="4" class="mb-md-0" v-if="doctorSelected && unitSelected">
                              <b-form-group
                                label="تاریخ"
                                label-for="start-time2"
                              >
                                <my-ab-date-picker
                                  :ref="selectedDate1 ? selectedDate1.toString() : 'selected-date'"
                                  :type="'date'"
                                  :locale="'fa,en'"
                                  click-on="all"
                                  :clearable="false"
                                  :show="false"
                                  :auto-submit="true"
                                  :column="1"
                                  v-model="selectedDate1"
                                  :toIso="true"
                                  :custom-hour="23"
                                  id="start-time2">
                                </my-ab-date-picker>
                              </b-form-group>
                            </b-col>
                            <!-- <b-col sm="3" class="mb-md-0" v-if="false">
                              <b-form-group v-if="timeOption && timeOption.length > 0"  label="نوبت های خالی ثبت شده" label-for="start-time3">
                                <my-v-select
                                  v-if="timeOption" 
                                  id="start-time3"
                                  v-model="timeSelected"
                                  :multiple="false"
                                  :options="timeOption.length ? timeOption : []"
                                  :translate="false"
                                  :searchable="true"
                                  :filterable="true"
                                  :clearable="true"
                                  @input="reserveTimeMove"
                                />                   
                                {{ timeSelected }}
                              </b-form-group>
                            </b-col> -->
                            <b-col sm="12" class="mb-md-0" v-if="selectedDate1 && timeOption && timeOption.length > 0 && !showMsg && showLoading">
                              <b-alert class="py-1 px-2 text-sm text-center lh-base" show variant="primary">لطفا منتظر بمانید ...</b-alert>
                            </b-col>
                            <b-col sm="12" class="mb-md-0" v-if="selectedDate1 && timeOption && timeOption.length == 0 && showMsg && !showLoading">
                              <b-alert class="py-1 px-2 text-sm text-center lh-base" show variant="danger">متاسفانه برای این پزشک در این تاریخ برنامه ای ثبت نشده است ، لطفا تاریخ دیگری را انتخاب کنید</b-alert>
                            </b-col>
                      </b-row>
                    </b-col>
                    <div class="reserve-modal plan-modal-footer">
                       <!-- <b-button
                        variant="primary"
                        v-if="turnUserId"
                        size="sm"
                        class="mr-1 p-0"
                        :disabled="!timeSelected"
                        style="height: 40px;padding: 5px 15px !important;"
                        @click="moveTurnItem"
                      >
                        انتقال نوبت
                      </b-button> -->
                    </div>
                  </b-tab>             
                </b-tabs>
              </b-card>
            </b-col>
          </div>
        </div>
      </div>
    </div>
    <!-- v-if="showModalDrag" -->
    <div class="modal modalDrag" tabindex="-1" v-if="showModalDrag">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">انتقال نوبت </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"  @click="closeModalMoveTurn">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
       <!-- آیا از انتقال بیمار <span class="redColor">{{ namePatient }}</span>, از تاریخ <span class="redColor">{{reserveDate }}</span>  ساعت <span class="redColor">{{ reserveFromTime }}</span>
        به تاریخ <span class="redColor">{{ toDate }}</span>  ساعت <span class="redColor">{{ timeSelected.fromTime }}</span>
         از دکتر <span class="redColor">{{ doctorInfo.planUserId.firstName }} {{ doctorInfo.planUserId.lastName }}</span> به دکتر <span class="redColor">{{ drNew.title }}</span>  مطمئن هستید؟ -->

         <span>آیا از <b>انتقال</b> نوبت <span class="redColor">{{ namePatient }} </span> <span v-if="nationalCodeTurn">با کد ملی <span  class="redColor">{{nationalCodeTurn}}</span></span></span>
          <table class="table table-bordered" style="margin-top:8px">
              <tr>
                <td>تاریخ</td>
                <td class="redColor">
                  <span>{{ dayIndex[keyDay].name }} {{ reserveDate }} </span>
                </td>
              </tr>
              <tr>
                <td>ساعت</td>
               <td class="redColor"> {{ reserveFromTime  }}</td>                
              </tr>
              <tr>
                <td>دکتر</td>
               <td class="redColor"> {{ doctorInfo.planUserId.firstName }} {{ doctorInfo.planUserId.lastName }}</td>                
              </tr>
            </table>
            <b> به </b>
            <table class="table table-bordered" style="margin-top:8px">
              <tr>
                <td>تاریخ</td>
                <td class="redColor">
                  {{dayNamed}} {{ toDate }} 
                </td>
              </tr>
              <tr>
                <td>ساعت</td>
               <td class="redColor"> {{ reserveTimeTitle  }}</td>                
              </tr>
              <tr>
                <td>دکتر</td>
               <td class="redColor"> {{ drNew }}</td>                
              </tr>
            </table>
            <span> <b>مطمئن</b> هستید؟</span>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" @click="closeModalMoveTurn">خیر</button>
        <button type="button" class="btn btn-transfer" @click="transferDr">بله </button>
      </div>
    </div>
  </div>
</div>
    <!--  -->
    <Print
      v-if="showPrintTurn"
      :reserveDate="reserveDate"
      :reserveFromTime="reserveFromTime1"
      :userName="firstName + ' ' + lastName"
      :nationalCode="nationalCode"
      :doctorInfoProps="doctorInfoProps"
      :doctorInfo="doctorInfo"
      :unitId="unitId"
      @close="showPrintTurn = false"
    />
  </div>
</template>

<script>
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";
import {
  BButton,
  BFormInput,
  BFormSelect,
  BTab,
  BTabs,
  BCol,
  BFormGroup,
  BFormCheckbox,
  BRow,
  BInputGroup,
  BFormRadioGroup,
  BInputGroupAppend,
  BFormText,
  BCard,
  BCardText,
  BForm,
  BAlert
} from "bootstrap-vue";
import datePicker from "@alireza-ab/vue-persian-datepicker";
import { mapGetters } from "vuex";
import filterRoles from "@/mixins/filterRoles";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker.vue";
import dateFormat from "@/mixins/dateFormat";
import flatPickr from "vue-flatpickr-component";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
import onlyEnglish from "@/mixins/onlyEnglish";
import nationalCodeValidation from "@/mixins/validations/nationalCode";
import mobileValidation from "@/mixins/validations/mobile";
import postalCodeValidation from "@/mixins/validations/postalCode";
import Print from "@/components/modal/PrintTurn.vue";
import moment from "jalali-moment";


export default {
  props: [
    "reserveEndTime",
    "planId",
    "timeId",
    "turnOfTimePlanDetailId",
    "isComeStatus",
    "turnUserId",
    "keyDay",
    "reserveFromTime",
    "reserveDate",
    "doctors",
    "doctorInfo",
    "past",
    "holidays",
    "today"
  ],
  data() {
    return {
      date: "",
      endDate: "",
      searchTime: ["00:00", "00:05"],
      selectDays: [],
      countOfQueue: 1,
      searchedUnits: "",
      isCome: false,
      tab: "createTab",
      searchTerm: "",
      selectUser: false,
      doctorOptions: [],
      doctorId: null,
      oldDayName:"",
      dayNamed:"",
      patientBySearch: "",
      days: [
        { key: 0, name: "شنبه ها", enName: "Saturdays" },
        { key: 1, name: "یکشنبه ها", enName: "Sundays" },
        { key: 2, name: "دوشنبه ها", enName: "Mondays" },
        { key: 3, name: "سه شنبه ها", enName: "Tuesdays" },
        { key: 4, name: "چهارشنبه ها", enName: "Wednesdays" },
        { key: 5, name: "پنجشنبه ها", enName: "Thursdays" },
        { key: 6, name: "جمعه ها", enName: "Fridays" },
      ],
      dayIndex: [
        { key: 0, name: "شنبه", enName: "Saturday" },
        { key: 1, name: "یکشنبه", enName: "Sunday" },
        { key: 2, name: "دوشنبه", enName: "Monday" },
        { key: 3, name: "سه شنبه", enName: "Tuesday" },
        { key: 4, name: "چهارشنبه", enName: "Wednesday" },
        { key: 5, name: "پنجشنبه", enName: "Thursday" },
        { key: 6, name: "جمعه", enName: "Friday" },
      ],
      modalShow: false,
      saturdays: [],
      sundays: [],
      mondays: [],
      tuesdays: [],
      wednesdays: [],
      thursdays: [],
      fridays: [],
      showForm: false,
      showFormFindUser: false,
      showPrintTurn: false,
      tab: null,
      isForeigner: false,
      lastNameSearch: "",
      fatherNameSearch: "",
      fullNameSearch: "",
      foreignerList: [],
      doctorInfo:'',
      doctorInfoProps:{},
      reserveFromTime1:'',
      reserveDate1:'',
      unitId:'',
      selectedDate1: null,
      doctorSelected: null,
      unitSelected : null,
      editMode : false,
      timeOption: [],
      users1: [],
      timeSelected : null,
      planDetailsId : null,
      reserveTimeTitle : null,
      planDetail: null,
      loadingTurn: false,
      newPatient : false,
      doctorSelectedId: null,
      unitSelectedId: null,
      timeSelectedId : null,
      unitOptions: [],
      showModalDrag:false,
      toDate:"",
      drNew:"",
      namePatient:"",
      roleDoctor:[],
      nationality:"",
      newPatientNonIr:false,
      showFormP:true,
      showMsg: false,
      showLoading: false,
      irani:true,
      timeOptionModal: false,
      unitTitle: null,
      showCome : false
    };
  },
  components: {
    BFormInput,
    MyAbDatePicker,
    flatPickr,
    required,
    requiredIf,
    minLength,
    maxLength,
    sameAs,
    MyVSelect,
    BFormSelect,
    BButton,
    BCol,
    BFormGroup,
    BRow,
    BTab,
    BTabs,
    datePicker,
    BFormCheckbox,
    BInputGroup,
    BFormRadioGroup,
    BInputGroupAppend,
    BFormText,
    Print,
    BCard,
    BCardText,
    BForm,
    BAlert
  },
  validations() {
    return {
      gender: {
        required,
      },
      nationalCode: {
        maxLength: maxLength(10),
        nationalCodeValidation: (value) =>
          !this.isForeigner ? this.nationalCodeValidation(value) : true,
        required: requiredIf(() => {
          return !this.isForeigner;
        }),
      },
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      mobile: {
        maxLength: maxLength(11),
        mobileValidation: (value) => this.tab=== 0 || this.countries.find((c) => {
        return c.phoneCode === 98;
      }) ? this.mobileValidation(value) : true ,
        required: requiredIf(()=>{
          return this.tab=== 0 || this.countries.find((c) => {
        return c.phoneCode === 98;
      })
        })
      },
      fatherName: {
        required: requiredIf(() => {
          return this.isForeigner;
        }),
      },
    };
  },
  
  mixins: [
    nationalCodeValidation,
    dateFormat,
    mobileValidation,
    postalCodeValidation,
    onlyEnglish,
    filterRoles,
  ],
  watch: {
    selectedDate1 (oldValue,newValue) {
      this.showMsg = false
      if(oldValue != newValue && newValue != null){
        this.timeSelected = null
        this.showLoading = true
        this.timeOption = []
      }
      if(oldValue != newValue && this.selectedDate1 != null){
        this.getPlanOneDay();
      }
      if(oldValue == newValue && newValue != null){
        this.timeOptionModal = true
      }
    },
    unitSelected (oldValue,newValue){
      if(oldValue != newValue && newValue != null){
        this.timeOption = []
        this.selectedDate1 = null
        this.timeSelected = null
      }
      else if(newValue == null){
        this.timeOption = []
        this.timeSelected = null
      }
      else if(oldValue == newValue && newValue != null){
        this.timeOption = []
      }
    },
    doctorSelected (oldValue,newValue){
      if(oldValue != newValue && newValue != null){
        this.timeOption = []
        this.selectedDate1 = null
        this.timeSelected = null
      }
      else if(newValue == null){
        this.timeOption = []
        this.unitOtions = []
        this.timeSelected = null
        this.doctorSelectedId = null
        this.unitSelected = null
      }
      else if(oldValue == newValue && newValue != null){
        this.timeOption = []
      }
    },
    tab() {
      this.showForm = false;
      this.firstName = "";
      this.lastName = "";
      this.fullNameSearch="",
      this.newPatientNonIr=false,
      this.gender = "female";
      this.mobile = "";
      this.nationality=""
      this.nationalCode = "";
      if(this.turnUserId && this.tab===0){
        this.$store.commit("SET_IS_LOADING", true);

      }
      if (this.tab === 1) {
        this.isForeigner = true;
        this.country = null
      } else {
        this.isForeigner = false;
        this.$store.dispatch("location/countries").then((countries) => {
        let iran = countries.find((c) => c["alpha_2"] === "IR")._id;
        if (this.turnUserId){
        this.$store.dispatch("user/findUser", this.turnUserId).then((res) => {
       setTimeout(()=>{
        this.nationalCodeTurn = res.nationalCode
        this.namePatient = res.firstName + ' ' + res.lastName
        if ( res) {
          if(  res.countryId === '614c4ec0359eae764b29a95c'){
          this.irani=true
        }else{
          this.irani=false
        }
          this.firstName = res.firstName;
          this.lastName = res.lastName;
          this.gender = res.gender;
          this.mobile = res.mobile;
          this.mobileCountryId = res.mobileCountryId;
          this.country = res.countryId;
          this.nationalCode = res.nationalCode;
          var nation =  countries.find((c) => c._id ===  res.countryId)
          if(nation && nation.title && nation.title.fa){
            this.nationality =  countries.find((c) => c._id ===  res.countryId).title.fa
          }
        }
        this.$store.commit("SET_IS_LOADING", false);

       },80)
      });
          }
          if(this.tab === 0){
            this.country = iran;
          }
          this.mobileCountryId = iran;
          this.countrySelected();
        });
      }
    },
  },
  created() {
    this.searchUser()
    this.$store.commit("user/RESET_MODULE");
    this.isCome = this.isComeStatus;
    if (this.turnUserId){
      this.$store.dispatch("location/countries").then((countries) => {
        let iran = countries.find((c) => c["alpha_2"] === "IR")._id;
        if(this.tab === 0){
            this.country = iran;
          }
        this.mobileCountryId = iran;
        this.countrySelected();
      });
      this.$store.dispatch("getRoles").then((res) => {
        if (res)
          this.roleFilter = res.find((r) => {
            return r.title == "patient";
          })._id;
      });
      this.newPatient = false
      // this.$store.dispatch("user/findUser", this.turnUserId).then((res) => {
      //  setTimeout(()=>{
      //   this.nationalCodeTurn = res.nationalCode
      //   this.namePatient = res.firstName + res.lastName
      //   if (res) {
      //     this.firstName = res.firstName;
      //     this.lastName = res.lastName;
      //     this.gender = res.gender;
      //     this.mobile = res.mobile;
      //     this.mobileCountryId = res.mobileCountryId;
      //     this.country = res.countryId;
      //     this.nationalCode = res.nationalCode;
      //     this.nationality =  this.countries.find((c) => c._id ===  res.countryId).title.fa
      //   }
      //  },100)
      // });
    }
    else{
      this.newPatient = true
    }
    this.$store.dispatch("getRoles").then((res) => {
        if (res)
          this.roleDoctor = res.find(
              (item) => item.title === "patient"
            )._id;
      });
  },
  mounted() {
    if(this.past == false && this.today == false ){
      this.showCome = false // feature time
    }
    else if(this.past == true && this.today == false){
      this.showCome = true // past time
    }
    else if(this.past == false && this.today == true){
      this.showCome = true // feature hours in current day
    }
    else {
      this.showCome = true // past hours in current day
    }
  },
  methods: {
    moveTurnItem () {
      this.timeOptionModal = false
      // var formatDay = new Date(this.selectedDate1)
      // this.toDate = new Intl.DateTimeFormat('fa-IR').format(formatDay);
      // var formatDay = formatDay.getDay(); 
      // var daysOfWeek = ["یک‌شنبه", "دو‌شنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه", "شنبه"];
      // this.dayNamed = daysOfWeek[formatDay]


   
    //  this.drNew=  this.doctorOptions.find(
    //     (item) => item._id === this.doctorSelected
    //   ).title;
      this.reserveTimeTitle =  this.timeOption.find(
        (item) => item.value == this.timeSelected
      ).text;
      this.planDetailsId =  this.planDetail.find(
        (item) => item.timeId == this.timeSelected
      ).planDetailId;
      // this.unitTitle =  this.unitOptions.find(
      //   (item) => item.timeId == this.unitSelected
      // ).title;
       this.showModalDrag = true
  },
  transferDr(){
    var argPayload = {
      newPDId : this.planDetailsId,
      newTId : this.timeSelected,
      oldPDId : this.planId,
      oldTId : this.timeId,
      turnId : this.turnOfTimePlanDetailId,
    }   
    this.moveTurn(argPayload)
 },
  moveTurn(args) {
    const payload = {
      displacementPlanDetailsId: args.newPDId,
      displacementTimeId: args.newTId,
      movePlanDetailsId: args.oldPDId,
      moveTimeId: args.oldTId,
      moveTurnId: args.turnId,
    };
      this.$store.dispatch("plan/updateForMove", payload)
        .then((res) => {
          if(res[0].status == "fail"){
            this.$bvToast.toast(res[0].description, {
              variant: "danger",
              solid: true,
            });
          }
          else{
            this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
              variant: "success",
              solid: true,
            });
            this.showModalDrag= false;   
            setTimeout(()=>{
              this.$emit("closeM");
              this.$emit("updateCal");

            },1000)                 
          }     
        })
        .catch((error) => {
          // this.$bvToast.toast(this.$t("toastification.submissionFailed"), {
          //   variant: "danger",
          //   solid: true,
          // });
        });
    },
    closeModalMoveTurn() {
      this.doctorSelected = null
      this.doctorSelectedId = null
      this.selectedDate1 = null
      this.timeOption = []
      this.timeSelected = null
      this.showModalDrag = !this.showModalDrag
    },NewPatientR(){
      this.newPatient=true
      this.showFormP = false
    },
    searchUser() {
      if(this.doctors != null || this.doctors.length != 0){
        for(let i = 0;i< this.doctors.length;i++){
              if (this.doctors[i].roles.find((role) => role.title === "doctor")) {
                this.doctorOptions.push({
                  _id: this.doctors[i]._id, title: `${this.doctors[i].firstName.toLowerCase()} ${this.doctors[i].lastName.toLowerCase()}`
                })
              }
            }
      }
      else{
        let payload = {};
        if (this.roleFilter && this.roleFilter.length) {
          payload.roles = this.roleFilter;
        }
        this.$store.dispatch("user/searchUsers", payload).then((res) => {
          if(res && res != undefined  ){
            for(let i = 0;i< res.length;i++){
              if (res[i].roles.find((role) => role === '60a384cef5660000d4001577')) {
                this.doctorOptions.push({
                  _id: res[i]._id, title: `${res[i].firstName.toLowerCase()} ${res[i].lastName.toLowerCase()}`
                })
              }
            }
          }
        });
      }
      
    },
    getPlanOneDay (){
      this.showLoading = true
      this.loadingTurn = false
      var nextStep = true
      var dayDate = moment(this.selectedDate1)
        .format("YYYY-MM-DD")
        .toLocaleString("en-GB", { timeZone: "UTC" });
        for(let i =0;i<this.holidays.length;i++){
          if(dayDate == this.holidays[i]){
            nextStep = false
          }
        }
        if(nextStep == true){
            const payload= {
              dayDate: dayDate,
              //endDate: end,
              planUserId: this.doctorSelected,
              status: "in_use",
              unitId: this.unitSelected
            }
            this.$store.dispatch("plan/searchPlanOneDay", payload).then((res) => {
              this.planDetail = res.data
              this.loadingTurn = false
              this.showLoading = false
              if(res && res.data.length == 0){
                this.showMsg = true
              }
              else{
                for(let i =0;i<res.data.length;i++){
                  if(res.data[i].maxTurn > 0){
                    if(res.data[i].turns && res.data[i].turns.length != 0){
                      if(res.data[i].maxTurn > res.data[i].turns.filter(n => n.isDeleted == false).length){
                        this.timeOption.push({
                          text: `${res.data[i].fromTime}`,
                          value: res.data[i].timeId
                        })
                      }
                    }
                    else{
                      this.timeOption.push({
                        text: `${res.data[i].fromTime}`,
                        value: res.data[i].timeId
                      })
                    }
                  }            
                }
                this.showMsg = false

                var formatDay = new Date(this.selectedDate1)
                this.toDate = new Intl.DateTimeFormat('fa-IR').format(formatDay);
                var formatDay = formatDay.getDay(); 
                var daysOfWeek = ["یک‌شنبه", "دو‌شنبه", "سه‌شنبه", "چهارشنبه", "پنج‌شنبه", "جمعه", "شنبه"];
                this.dayNamed = daysOfWeek[formatDay]

                this.unitTitle =  this.unitOptions.find(
                  (item) => item._id == this.unitSelected
                ).title;

                this.drNew=  this.doctorOptions.find(
                  (item) => item._id === this.doctorSelected
                ).title;

                this.timeOptionModal = true
              }
            });
        }
        else{
          this.$bvToast.toast('متاسفانه این تاریخ در تقویم مرکز تعطیل می باشد، لطفا تاریخ دیگری را انتخاب کنید', {
            variant: "danger",
            solid: true,
          });
        }
    },
    async FinalRegistration() {
      this.$v.$touch();
      if(this.mobile === "" && this.tab === 1){
        this.$bvToast.toast(this.$t("toastification.errMobile"), {
            variant: "danger",
            solid: true,
          });
      }
        if(this.mobile.length<11 && this.tab===1){
        this.$bvToast.toast("شماره موبایل به درستی وارد نشده است.", {
          title: this.$t("toastification.success"),
          variant: "danger",
          solid: true,
        });
      } 
      if (!this.$v.$invalid) {
        let payload = {
          firstName: this.firstName ,
          lastName: this.lastName ,
          gender: this.gender,
          mobile: this.mobile,
          mobileCountryId: this.mobileCountryId,
          countryId: this.country,
          status: "active",
          roles:[this.roleDoctor],
          fatherName: this.fatherName,
        };
        if (this.tab === 0) {
          Object.assign(payload, { nationalCode: this.nationalCode });
        }
        if (this.patientBySearch) {
          const userRole = [];
          for (const role of this.roleFilter) {
            userRole.push(this.roles.find((item) => item._id === role));
          }
          if (this.roles.find((item) => item.title === "patient")) {
            const payload = {
              planDetailId: this.planId,
              timeId: this.timeId,
              turnUserId: this.patientBySearch,
            };
            this.$store
              .dispatch("plan/reservePlan", payload)
              .then((res) => {
                this.$emit("newReserveData", res);
                this.$emit("closeM");
              })
              .catch((error) => {
                let msg = "";
                switch (error.response.status) {
                  case 422:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 404:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 400:
                    msg = this.$t("toastification.badRequest");
                    break;
                }

                this.$bvToast.toast(msg, {
                  title: this.$t("toastification.error"),
                  variant: "danger",
                  solid: true,
                });
              });
          } else {
            const newRole = this.roles.find(
              (item) => item.title === "patient"
            )._id;
            if (newRole) this.roleFilter.push(newRole);
            const payload = {
              roles: this.roleFilter,
            };

            this.$store
              .dispatch("user/editUser", {
                items: payload,
                userId: this.patientBySearch,
              })
              .then((res) => {
                const payload = {
                  planDetailId: this.planId,
                  timeId: this.timeId,
                  turnUserId: this.patientBySearch,
                };
                this.$store
                  .dispatch("plan/reservePlan", payload)
                  .then((res) => {
                    this.$emit("newReserveData", res);
                    this.$emit("closeM");
                  })
                  .catch((error) => {
                    let msg = "";
                    switch (error.response.status) {
                      case 422:
                        msg = this.$t("toastification.deletionFailed");
                        break;

                      case 404:
                        msg = this.$t("toastification.deletionFailed");
                        break;

                      case 400:
                        msg = this.$t("toastification.badRequest");
                        break;
                    }

                    this.$bvToast.toast(msg, {
                      title: this.$t("toastification.error"),
                      variant: "danger",
                      solid: true,
                    });
                  });
              });
          }
        } else {
          this.$store.dispatch("user/registerUser", payload).then((res) => {
            const payload = {
              planDetailId: this.planId,
              timeId: this.timeId,
              turnUserId: res._id,
            };

            this.$store
              .dispatch("plan/reservePlan", payload)
              .then((res) => {
                this.$emit("newReserveData", res);
                this.$emit("closeM");
              })
              .catch((error) => {
                let msg = "";
                switch (error.response.status) {
                  case 422:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 404:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 400:
                    msg = this.$t("toastification.badRequest");
                    break;
                }

                this.$bvToast.toast(msg, {
                  title: this.$t("toastification.error"),
                  variant: "danger",
                  solid: true,
                });
              });
          });
        }
      } else {
        const invalidFields = Object.keys(this.$v.$params).filter(
          (fieldName) => this.$v[fieldName].$invalid
        );
        this.$nextTick(() => {
          const el = document.querySelector(".is-invalid:first-of-type");
          return;
        });
      }
    },
    async reserve(item) {
      this.$v.$touch();
      this.selectForeignUser(item)
      if(!item.fatherName){
        this.$bvToast.toast(this.$t("toastification.ErrFatherName"), {
          variant: "danger",
          solid: true,
        });
      }
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let payload = {
          firstName: this.firstName ? this.firstName : item.firstName,
          lastName: this.lastName ? this.lastName : item.lastName,
          gender: this.gender ? this.gender : item.gender,
          mobile: this.mobile ? this.mobile : item.mobile,
          mobileCountryId: this.mobileCountryId ? this.mobileCountryId : item.mobileCountryId,
          countryId: this.country ? this.country : item.country,
          status: "active",
          roles:[this.roleDoctor],
          fatherName: this.fatherName ? this.fatherName : item.fatherName,
        };
        if (this.tab === 0) {
          Object.assign(payload, { nationalCode: this.nationalCode });
        }
        if (this.patientBySearch) {
          const userRole = [];
          for (const role of this.roleFilter) {
            userRole.push(this.roles.find((item) => item._id === role));
          }
          if (this.roles.find((item) => item.title === "patient")) {
            const payload = {
              planDetailId: this.planId,
              timeId: this.timeId,
              turnUserId: this.patientBySearch,
            };
            this.$store
              .dispatch("plan/reservePlan", payload)
              .then((res) => {
                this.$emit("newReserveData", res);
                this.$emit("closeM");
              })
              .catch((error) => {
                let msg = "";
                switch (error.response.status) {
                  case 422:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 404:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 400:
                    msg = this.$t("toastification.badRequest");
                    break;
                }

                this.$bvToast.toast(msg, {
                  title: this.$t("toastification.error"),
                  variant: "danger",
                  solid: true,
                });
              });
          } else {
            const newRole = this.roles.find(
              (item) => item.title === "patient"
            )._id;
            if (newRole) this.roleFilter.push(newRole);
            const payload = {
              roles: this.roleFilter,
            };

            this.$store
              .dispatch("user/editUser", {
                items: payload,
                userId: this.patientBySearch,
              })
              .then((res) => {
                const payload = {
                  planDetailId: this.planId,
                  timeId: this.timeId,
                  turnUserId: this.patientBySearch,
                };
                this.$store
                  .dispatch("plan/reservePlan", payload)
                  .then((res) => {
                    this.$emit("newReserveData", res);
                    this.$emit("closeM");
                  })
                  .catch((error) => {
                    let msg = "";
                    switch (error.response.status) {
                      case 422:
                        msg = this.$t("toastification.deletionFailed");
                        break;

                      case 404:
                        msg = this.$t("toastification.deletionFailed");
                        break;

                      case 400:
                        msg = this.$t("toastification.badRequest");
                        break;
                    }

                    this.$bvToast.toast(msg, {
                      title: this.$t("toastification.error"),
                      variant: "danger",
                      solid: true,
                    });
                  });
              });
          }
        } else {
          this.$store.dispatch("user/registerUser", payload).then((res) => {
            const payload = {
              planDetailId: this.planId,
              timeId: this.timeId,
              turnUserId: res._id,
            };

            this.$store
              .dispatch("plan/reservePlan", payload)
              .then((res) => {
                this.$emit("newReserveData", res);
                this.$emit("closeM");
              })
              .catch((error) => {
                let msg = "";
                switch (error.response.status) {
                  case 422:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 404:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 400:
                    msg = this.$t("toastification.badRequest");
                    break;
                }

                this.$bvToast.toast(msg, {
                  title: this.$t("toastification.error"),
                  variant: "danger",
                  solid: true,
                });
              });
          });
        }
      } else {
        const invalidFields = Object.keys(this.$v.$params).filter(
          (fieldName) => this.$v[fieldName].$invalid
        );
        this.$nextTick(() => {
          const el = document.querySelector(".is-invalid:first-of-type");
          return;
        });
      }
    },
    async deleteReserve() {
      this.$bvModal
        .msgBoxConfirm(this.$t("general.confirmDelete"), {
          title: this.$t("general.confirmDeleteTitle"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("general.yes"),
          cancelTitle: this.$t("general.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.$emit("removeReserveData");
            this.$emit("closeM");
          }
        });
    },
    preventMobileType(value) {
      if (this.mobile.length >= 11) {
        value.preventDefault();
        return;
      }
    },
    doctorSelectedMove() {
      let selected = this.doctorOptions.find((c) => {
        return c._id == this.doctorSelected;
      });
      this.unitOptions = []
      this.doctorSelectedId = selected;
      var fIndex = this.doctors.findIndex(item => item._id === this.doctorSelected);
      this.unitOptions = this.doctors[fIndex].units 
      if(this.unitOptions.length == 1){
          this.unitSelected = this.unitOptions[0]._id
      }
    },
    unitSelectedMove() {
      let selected = this.unitOptions.find((c) => {
        return c._id == this.unitSelected;
      });
      this.unitSelectedId = selected;
    },
    reserveTimeMove(e) {
      let selected = this.timeOption.find((c) => {
        return c.value == this.timeSelected;
      });
      this.timeSelectedId = selected;
    },
    countrySelected() {
      let selected = this.countries.find((c) => {
        return c._id == this.country;
      });
      if (selected["alpha_2"] === "AF") {
        this.mobileCountryId = this.countries.find((c) => {
          return c["alpha_2"] === "AF";
        })._id;
        selected.phoneCode = 98;
      } else {
        this.mobileCountryId = this.country;
      }
      if (selected["alpha_2"] == "IR") {
        this.isForeigner = false;
      } else {
        this.isForeigner = true;
      }
    },
    closeModal() {
      this.$emit("closeM");
    },
    async changeIsCome() {
      if(this.Past != 'false'){
        const payload = {
          timeId: this.timeId,
          planDetailId: this.planId,
          turnOfTimePlanDetailId: this.turnOfTimePlanDetailId,
          isCome: this.isCome,
        };

        this.$store
          .dispatch("plan/updateForCome", payload)
          .then((res) => {
            this.$emit("newReserveData", res);
            this.$emit("closeM");
          })
          .catch((error) => {
            let msg = "";
            switch (error.response.status) {
              case 422:
                msg = this.$t("toastification.deletionFailed");
                break;

              case 404:
                msg = this.$t("toastification.deletionFailed");
                break;

              case 400:
                msg = this.$t("toastification.badRequest");
                break;
            }

            this.$bvToast.toast(msg, {
              title: this.$t("toastification.error"),
              variant: "danger",
              solid: true,
            });
          });
      }
      else{
        this.$bvToast.toast('امکان تغییر مراجعه نوبت به دلیل اینکه زمان این نوبت در آينده می باشد، وجود ندارد', {
                title: this.$t("toastification.error"),
                variant: "danger",
                solid: true,
              });
      }
    },
    changeTab(tab) {
      this.tab = tab;
    },
    selectForeignUser(item) {
      this.patientBySearch = item._id;
      this.gender = item.gender;
      this.firstName = item.firstName;
      this.lastName = item.lastName;
      this.fatherName = item.fatherName;
      this.mobile = item.mobile;
      this.mobileCountryId = item.mobileCountryId;
      this.countryId = item.country;
      this.roleFilter = item.roles;
      this.nationalCode = item.nationalCode;
    },
    nationalCodeValidation(value) {
            let validate = false;
            if (value && value.length == 10) {
                const nationalCode = value.split("");
                let num = nationalCode.map((n, index) => {
                    if (10 - index > 1) return n * (10 - index);
                    return 0;
                });
                const reducer = (accumulator, currentValue) =>
                    accumulator + currentValue;
                let res = Math.floor(num.reduce(reducer) % 11);
                if (res >= 2) {
                    11 - res == parseInt(nationalCode[9])
                        ? (validate = true)
                        : (validate = false);
                } else {
                    res == parseInt(nationalCode[9])
                        ? (validate = true)
                        : (validate = false);
                }
            }
            return validate;
        },
    findUser(event) {
      event.preventDefault()
      this.showForm = false;
      this.showFormP = true
      let payload = {};
      if(this.nationalCodeValidation(this.searchTerm) && this.tab ===0 || this.tab === 1){
        if (this.tab === 0) {
          Object.assign(payload, { nationalCode: this.searchTerm });
        } else {
          this.searchTerm = "";
          if(this.country){
            Object.assign(payload, {
              countryId: this.country ? this.country : null,
            });
          }
          if (this.fullNameSearch) {
            Object.assign(payload, {
              fullName: this.fullNameSearch + this.lastNameSearch,
              // lastName: this.lastNameSearch,
            });
          }
          // if (this.lastNameSearch) {
          //   Object.assign(payload, {
          //     lastName: this.lastNameSearch,
          //   });
          // }
          if (this.fatherNameSearch) {
            Object.assign(payload, {
              fatherName: this.fatherNameSearch,
            });
          }
        }

      let find =
        (this.tab === 0 && this.searchTerm) || (this.tab === 1 && this.fatherNameSearch && this.country ) || (this.tab === 1 && this.fullNameSearch && this.country) 

      if (find) {
        this.newPatient = false
        this.nationalCode = this.searchTerm;
        this.$store.commit("SET_IS_LOADING", true);
        this.$store
          .dispatch("user/searchUsers", payload)
          .then((res) => {
            this.showForm = true;
            if(this.tab=== 1){
                  this.newPatientNonIr = true
                }
            this.$store.commit("SET_IS_LOADING", false);
            if (res && res.length > 0) {
              this.foreignerList = res;
              this.showForm = true;
              if (this.tab === 0) {
                this.patientBySearch = res[0]._id;
                this.gender = res[0].gender;
                this.firstName = res[0].firstName;
                this.lastName = res[0].lastName;
                this.fatherName = res[0].fatherName;
                this.mobile = res[0].mobile;
                this.mobileCountryId = res[0].mobileCountryId;
                this.countryId = res[0].country;
                this.roleFilter = res[0].roles;
                this.nationalCode = this.nationalCode ? this.searchTerm : null;
              }
            } else {
              if(this.tab===0){
                this.newPatient = true
              }
              this.firstName = this.firstNameSearch;
              this.lastName = this.lastNameSearch;
              this.fatherName = this.fatherNameSearch;
              this.gender = "female";
              this.patientBySearch = "";
              // this.firstName = "";
              // this.lastName = "";
              this.mobile = "";
              this.nationalCode = this.searchTerm;
              this.foreignerList = [];
            }
          })
          .catch((error) => {
            this.showForm = false;
            this.$store.commit("SET_IS_LOADING", false);
            this.$bvToast.toast(this.$t("toastification.userNotFound"), {
              variant: "danger",
              solid: true,
            });
            // this.$store.dispatch("getRoles").then((res) => {
            //   if (res)
            //     this.roleFilter = res.find((r) => {
            //       return r.title == "patient";
            //     })._id;
            // });
            this.patientBySearch = "";
            this.gender = "female";
            this.firstName = "";
            this.fatherName = "";
            this.lastName = "";
            this.mobile = "";
            this.nationalCode = this.searchTerm;
            
          });
        }
        else{
          if(this.country === null){
            this.newPatient = true
          this.$bvToast.toast(this.$t("toastification.ErrorFindCountry"), {
          variant: "danger",
          solid: true,
        });
          }
          else{
            this.newPatient = true
          this.$bvToast.toast(this.$t("toastification.ErrorFind"), {
          variant: "danger",
          solid: true,
        });
          }
        }
      }
      else{
        this.$bvToast.toast(this.$t("toastification.nationCodeLengthError"), {
          variant: "danger",
          solid: true,
        });
      }
    },
    preventNationalType(value) {
      if (this.nationalCode.length >= 10) {
        value.preventDefault();
        return;
      }
    },
    registerUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let payload = {
          firstName: this.firstName,
          lastName: this.lastName,
          username: this.username,
          gender: this.gender,
          mobile: this.mobile,
          mobileCountryId: this.mobileCountryId,
          countryId: this.country,
          fatherName: this.fatherName,
        };
        this.$store
          .dispatch("user/registerUser", payload)
          .then((res) => {
            this.$store
              .dispatch("user/uploadDocs", res._id)
              .then((res) => {
                this.$bvToast.toast(
                  this.$t("toastification.submissionSucceed"),
                  {
                    variant: "success",
                    solid: true,
                  }
                );
                this.roleFilter = this.role;
                this.$router.push({ name: "manageUsers" });
              })
              .catch((error) => {
                this.$bvToast.toast(
                  this.$t("toastification.submissionFailed"),
                  {
                    variant: "danger",
                    solid: true,
                  }
                );
              });
          })
          .catch((error) => {
            if (error.message.includes("NationalCode is invalid")) {
              this.$bvToast.toast("dhdh"),
                {
                  variant: "danger",
                  solid: true,
                };
            } else {
              this.$bvToast.toast(this.$t("toastification.submissionFailed"), {
                variant: "danger",
                solid: true,
              });
            }
          });
      } else {
        const invalidFields = Object.keys(this.$v.$params).filter(
          (fieldName) => this.$v[fieldName].$invalid
        );
        this.$nextTick(() => {
          const el = document.querySelector(".is-invalid:first-of-type");
          el.scrollIntoView({ behavior: "instant", block: "center" });
          el.scrollIntoView();
          return;
        });
      }
    },
     getTurnInfo(){
      const payload = {
        planDetailId: this.planId,
        timeId: this.timeId,
        turnOfTimePlanDetailId: this.turnOfTimePlanDetailId,
      };
      this.$store
        .dispatch("plan/getTurnInfo", payload)
        .then((res) => {
          this.doctorInfoProps=res;
          this.userName = this.doctorInfoProps.turnUserId.firstName + ' '+ this.doctorInfoProps.turnUserId.lastName
          this.doctorInfo =  this.doctorInfoProps.planUserId.firstName + " " +  this.doctorInfoProps.planUserId.lastName
          this.unitId=  this.doctorInfoProps.unitId.title
          this.reserveFromTime1 =  this.doctorInfoProps.fromTime
        const date= moment(this.doctorInfoProps.date, "YYYY-MM-DD");
        const formattedDate= date.format("jYYYY-jMM-jDD");
        this.reserveDate1 =  formattedDate
      });     
      this.showPrintTurn= true
    },
    validateInput(event) {
      const charCode = event.charCode;
      if (charCode >= 48 && charCode <= 57) {
        event.preventDefault();
      }
    }
  },
  computed: {
    ...mapGetters({
      units: "units/units",
      genders: "user/genders",
      valid: "validation/valid",
      countries: "location/countries",
      cities: "location/cities",
      roles: "roles",
    }),
    // doctorInfoProps() {
    //   return this.doctorInfo;
    // },
    firstName: {
      set(name) {
        this.$store.commit("user/SET_FIRSTNAME", name);
      },
      get() {
        return this.$store.getters["user/firstName"];
      },
    },
    lastName: {
      set(lastName) {
        this.$store.commit("user/SET_LASTNAME", lastName);
      },
      get() {
        return this.$store.getters["user/lastName"];
      },
    },
    nationalCode: {
      set(nationalCode) {
        this.$store.commit("user/SET_NATIONALCODE", nationalCode);
      },
      get() {
        return this.$store.getters["user/nationalCode"];
      },
    },
    mobile: {
      set(mobile) {
        this.$store.commit("user/SET_MOBILE", mobile);
      },
      get() {
        return this.$store.getters["user/mobile"];
      },
    },
    mobileCountryId: {
      set(mobileCountryId) {
        this.$store.commit("user/SET_MOBILE_COUNTRY_ID", mobileCountryId);
      },
      get() {
        return this.$store.getters["user/mobileCountryId"];
      },
    },
    country: {
      set(country) {
        this.$store.commit("user/SET_COUNTRY", country);
      },
      get() {
        return this.$store.getters["user/country"];
      },
    },
    gender: {
      set(gender) {
        this.$store.commit("user/SET_GENDER", gender);
      },
      get() {
        return this.$store.getters["user/gender"];
      },
    },
    fatherName: {
      set(fatherName) {
        this.$store.commit("user/SET_FATHERNAME", fatherName);
      },
      get() {
        return this.$store.getters["user/fatherName"];
      },
    },
    roleFilter: {
      set(role) {
        this.$store.commit("user/SET_ROLE_FILTER", role);
      },
      get() {
        return this.$store.getters["user/roleFilter"];
      },
    },
    invalidFeedbackGender: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.gender.$dirty) return error;
        if (!this.$v.gender.required) error = "required";
        return error;
      },
    },
    invalidFeedbackFirstName: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.firstName.$dirty) return error;
        if (!this.$v.firstName.required) error = "required";
        return error;
      },
    },
    invalidFeedbackFatherName: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.fatherName.$dirty) return error;
        if (!this.$v.fatherName.required) error = "required";
        return error;
      },
    },
    invalidFeedbackNationalCode: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.nationalCode.$dirty) return error;
        if (!this.$v.nationalCode.required) {
          error = "required";
          return error;
        }
        if (!this.$v.nationalCode.nationalCodeValidation) {
          error = "invalid";
          return error;
        }
        return error;
      },
    },
    invalidFeedbackMobile: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.mobile.$dirty) return error;
        if (!this.$v.mobile.required) {
          error = "required";
          return error;
        }
        if (!this.$v.mobile.mobileValidation) {
          error = "invalid";
          return error;
        }
        if (!this.$v.mobile.notTheSame) error = "notSameAs";
        return error;
      },
    },
    invalidFeedbackConfirm: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.confirm.$dirty) return error;
        if (!this.$v.confirm.sameAs) error = "sameAs";
        return error;
      },
    },
    invalidFeedbackLastname: {
      set(error) {},
      get() {
        var error = "";
        if (!this.$v.lastName.$dirty) return error;
        if (!this.$v.lastName.required) error = "required";
        return error;
      },
    },
    statusVariant() {
      const statusColor = {
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
      };
      return (status) => statusColor[status];
    },
    countriesWithCode() {
      return this.countries.map(country => ({
        ...country,
        titleAndCode: `${country.phoneCode} `
      }));
    }
  },
};
//
</script>

<style scoped>

.has-double-border {
  border: 4px #b4b7bd8c double;
  border-radius: 5px;
  background: #f4f4f433;
  padding: 20px 10px 20px 10px;
}
.bg-gray {
  border-top: 1px #b4b7bd8c dashed;
  border-bottom: 1px #b4b7bd8c dashed;
  background: #f7f7f7;
  padding: 20px 10px 20px 10px;
  z-index: 1000;
}
.wrapper-component .vs__dropdown-menu{
  z-index: 1000 !important;
}
.plan-tab-content .card{
  box-shadow: none !important;
}
.v-input.v-text-field{
  padding: 0.438rem 1rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
  height: 38px;
}
.v-list.v-select-list{
  width: 248px !important;
}
.radio-flex{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(8rem, 1fr));
  grid-gap: 0.5rem;
  grid-column: 1/ -1;
}
.modal-header-time{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(33%, 1fr));
  grid-gap: 0.5rem;
  grid-column: 1/ -1;
  background: #05b4ab;
  border-bottom: 1px solid #02b3aa;
  border-radius: 10px;
  padding: 2px 8px;
  margin-bottom: 5px;
}
.modal-header-time .g-box{
  text-align: center;
  margin: 0 auto;
}
.modal-header-time span{
  font-weight: bold;
  display: block;
  margin: 2px auto;
  color: white;
}
.modal-header-time p{
  display: block;
  margin: 2px auto;
  color: white;
}
.plan-modal.plan .plan-content{
  overflow:auto !important
}
.paddingTop{
  padding-top:101px
}
</style>
